import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

export function getEquipmentsList(company_id, include_data) {
    let url = `${API_URL}/bewhere/companies/${company_id}/trackers/list`;

    if (include_data) {
        url += `?include_data=${include_data}`;
    }

    const settings = {
        async: true,
        crossDomain: true,
        url,
        method: 'GET',
        dataType: 'jsonp',
        withCredentials: true,
    }

    return axios(settings);
}

export function getEquipmentsOfGroup(data) {
    const url = `${API_URL}/bewhere/groups/${data.groupId}/trackers`;

    let settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: 'GET',
        withCredentials: true
    }

    return axios(settings);
}

export function addEquipmentToGroup(groupId , beacon_id){
    const url = `${API_URL}/bewhere/groups/${groupId}/trackers/${beacon_id}`;

    const settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: 'PUT',
        withCredentials: true
    }

    return axios(settings);
}

export function removeEquipmentFromGroup(groupId , beacon_id){
    const url = `${API_URL}/bewhere/groups/${groupId}/trackers/${beacon_id}`;

    const settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: 'DELETE',
        withCredentials: true
    }

    return axios(settings);
}

export function getEquipmentDates(beacon_id) {
    const url = `${API_URL}/bewhere/trackers/${beacon_id}/get_dates`;

    const settings = {
        async: true,
        crossDomain: true,
        url,
        method: 'GET',
        dataType: 'jsonp',
        withCredentials: true,
    }

    return axios(settings);
}

export function getEquipmentMetaData(data) {
    const url = `${API_URL}/bewhere/trackers/${data.beacon_id}/metadata?date=${data.date}`;

    const settings = {
        async: true,
        crossDomain: true,
        url,
        method: 'GET',
        dataType: 'jsonp',
        withCredentials: true,
    }

    return axios(settings);
}

